// @ts-ignore
import {animate, AnimationTransitionMetadata, style, transition} from '@angular/animations';

export function smoothEnterLeaveAnimation(enterTiming: string, leaveTiming: string): AnimationTransitionMetadata[] {
  return [
    transition(':enter', [
      style({opacity: 0, height: 0, overflow: 'hidden'}),
      animate(enterTiming + ' ease-in-out', style({opacity: 1, height: '*'}))
    ]),
    transition(':leave', [
      animate(leaveTiming + ' ease-in-out', style({opacity: 0, height: 0}))
    ])
  ];
}
